<template>
  <z-select
    v-model="currentVal"
    :options="options"
    v-bind="$attrs"
    v-on="$listeners"
    @visible-change="visibleChange"
  />
</template>
<script>
import { fetchOptions } from './fetch'
export default {
  name: 'DictSelect',
  props: {
    dictKey: String,
    value: {},
    cache: {
      type: Boolean,
      default: true
    },
    asyncLoadData: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentVal: this.value,
      options: []
    }
  },
  watch: {
    currentVal(val) {
      this.$emit('input', val)
    },
    value(value) {
      this.currentVal = value
    },
    dictKey() {
      this.getOptions()
    }
  },
  created() {
    let cache = this.cache
    if (this.asyncLoadData) {
      cache = false
    }
    this.getOptions(cache)
  },
  methods: {
    visibleChange(bol) {
      if (bol && this.asyncLoadData) {
        this.getOptions(false)
      }
    },
    getOptions(cache = true) {
      fetchOptions(this.dictKey, cache).then(res => {
        this.options = res || []
        this.$emit('get-options', this.options)
      })
    }
  },
}
</script>
